import initialState from './initialState';
import { reducer as createMailTemplateReducer } from './createMailTemplate';
import { reducer as createSmsTemplateReducer } from './createSmsTemplate';
import { reducer as fetchAllSmsTemplateReducer } from './fetchAllSmsTemplate';
import { reducer as fetchAllMailTemplateReducer } from './fetchAllMailTemplate';
import { reducer as fetchTemplateReducer } from './fetchTemplate';
import { reducer as updateTemplateReducer } from './updateTemplate';
import { reducer as loadCollectionsReducer } from './loadCollections';
import { reducer as deleteTemplateReducer } from './deleteTemplate';
import { reducer as createTooltipTemplateReducer } from './createTooltipTemplate';
import { reducer as fetchAllTooltipTemplateReducer } from './fetchAllTooltipTemplate';
import { reducer as getPermissionFlagsReducer } from './getPermissionFlags';
import { reducer as createAgreementTemplateReducer } from './createAgreementTemplate';
import { reducer as fetchAllAgreementTemplateReducer } from './fetchAllAgreementTemplate';
import { reducer as fetchAllTypesenseSearchTemplateReducer } from './fetchAllTypesenseSearchTemplate';
import { reducer as createTypesenseSearchTemplateReducer } from './createTypesenseSearchTemplate';
import { reducer as createSocketIoTemplateReducer } from './createSocketIoTemplate';
import { reducer as fetchAllSocketIoTemplateReducer } from './fetchAllSocketIoTemplate';
import { reducer as generateTemplateReducer } from './generateTemplate';

const reducers = [
  createMailTemplateReducer,
  createSmsTemplateReducer,
  fetchAllSmsTemplateReducer,
  fetchAllMailTemplateReducer,
  fetchTemplateReducer,
  updateTemplateReducer,
  loadCollectionsReducer,
  deleteTemplateReducer,
  createTooltipTemplateReducer,
  fetchAllTooltipTemplateReducer,
  getPermissionFlagsReducer,
  createAgreementTemplateReducer,
  fetchAllAgreementTemplateReducer,
  fetchAllTypesenseSearchTemplateReducer,
  createTypesenseSearchTemplateReducer,
  createSocketIoTemplateReducer,
  fetchAllSocketIoTemplateReducer,
  generateTemplateReducer,
];

export default function reducer(state = initialState, action) {
  let newState;
  switch (action.type) {
    // Handle cross-topic actions here
    default:
      newState = state;
      break;
  }
  return reducers.reduce((s, r) => r(s, action), newState);
}
